<template>
  <div class="document-pill">
    <BasePill v-bind="{ ...$props, ...$attrs }">
      <template #icon>
        <DocumentIcon16 />
      </template>
    </BasePill>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DocumentIcon16 from '@components/Icons/DocumentIcon16.vue';
import BasePill from '@components/common/BasePill.vue';

export default defineComponent({
  name: 'DocumentPill',

  components: {
    DocumentIcon16,
    BasePill,
  },
});
</script>
